import script from "./CategoryTree.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryTree.vue?vue&type=script&setup=true&lang=ts"

import "./CategoryTree.vue?vue&type=style&index=0&id=72f3d1fb&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72f3d1fb"]])

export default __exports__